import { render, staticRenderFns } from "./PlatformNotifications.vue?vue&type=template&id=3ca5e9d0"
import script from "./PlatformNotifications.vue?vue&type=script&lang=js"
export * from "./PlatformNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports